'use strict';

import { Dropdown } from './dropdown';

require('../utils/closestPolyfill');

const KEYCODE = {
    DOWN: 40,
    RETURN: 13
};

export function SelectSearchResultInput(params) {
    const element = params.element;
    const searchInput = params.searchInput || null;
    const getOptions = (params.getOptions && typeof params.getOptions === 'function') ? params.getOptions : null;
    const onChange = (params.onChange && typeof params.onChange === 'function') ? params.onChange : null;
    const onInput = (params.onInput && typeof params.onInput === 'function') ? params.onInput : null;

    if (element && getOptions) {
        let typingTimeout = null;
        let search = null;

        const parentElement = element.parentElement;
        let spinnerParentElement = typeof parentElement.dataset.spinnerParent === 'string' ? parentElement : parentElement.closest('[data-spinner-parent]');

        if (!spinnerParentElement) {
            spinnerParentElement = parentElement;
        }

        const spinnerElement = document.createElement('span');
        spinnerElement.innerHTML = '&#8987;';

        if (element.nodeName === 'INPUT') {
            search = element.value;

            let dropdown = null;
            let dropdownElement = null;
            let dropdownCTAElement = null;
            let dropdownListBoxElement = null;

            function removeSuggestions() {
                const dropdownElement = parentElement.querySelector('.dropdown');

                if (dropdownElement) {
                    parentElement.removeChild(dropdownElement);
                }

                dropdown = null;
                dropdownListBoxElement = null;
            }

            element.addEventListener('keydown', function (event) {
                const key = event.which || event.keyCode;

                if (key) {
                    switch (key) {
                        case KEYCODE.RETURN:
                            event.preventDefault();
                            if (onChange) onChange(dropdown.getSelectedOptionValue());
                            removeSuggestions();
                            break;
                        case KEYCODE.DOWN:
                            event.preventDefault();
                            dropdownCTAElement.click();
                            break;
                    }
                }
            });

            element.addEventListener('input', function () {
                if (this.value !== search) {
                    if (onInput) onInput(this.value);

                    clearTimeout(typingTimeout);

                    search = this.value || '';

                    if (search.length >= 2) {
                        spinnerParentElement.append(spinnerElement);

                        typingTimeout = setTimeout(function () {
                            getOptions(
                                search,
                                function (options) {
                                    if (options && options.length) {

                                        if (!dropdown) {
                                            dropdownElement = document.createElement('div');
                                            dropdownElement.classList.add('dropdown');

                                            dropdownCTAElement = document.createElement('div');
                                            dropdownCTAElement.classList.add('dropdown__cta');
                                            dropdownCTAElement.setAttribute('aria-haspopup', 'listbox');
                                            dropdownCTAElement.style.display = 'none';

                                            dropdownListBoxElement = document.createElement('ul');
                                            dropdownListBoxElement.setAttribute('role', 'listbox');
                                            dropdownListBoxElement.setAttribute('tabindex', '-1');
                                            dropdownListBoxElement.classList.add('dropdown__options-list', 'dropdown__options-list--hidden');

                                            dropdownElement.append(dropdownCTAElement);
                                            dropdownElement.append(dropdownListBoxElement);
                                            parentElement.append(dropdownElement);

                                            dropdown = Dropdown(
                                                {
                                                    dropdownElement: dropdownElement,
                                                    onEnter: function (value) {
                                                        if (onChange) onChange(value);
                                                        removeSuggestions();
                                                    }
                                                }
                                            );
                                        } else {
                                            dropdown.updateOptions([]);
                                        }

                                        dropdown.updateOptions(options);
                                        dropdown.selectOption(dropdownListBoxElement.firstChild);
                                        dropdownListBoxElement.classList.remove('dropdown__options-list--hidden');

                                        if (spinnerParentElement.contains(spinnerElement)) spinnerParentElement.removeChild(spinnerElement);
                                    } else {
                                        removeSuggestions();
                                        if (spinnerParentElement.contains(spinnerElement)) spinnerParentElement.removeChild(spinnerElement);
                                    }
                                },
                                function () {
                                    removeSuggestions();
                                    if (spinnerParentElement.contains(spinnerElement)) spinnerParentElement.removeChild(spinnerElement);
                                }
                            );
                        }, 500);
                    } else {
                        removeSuggestions();
                    }
                }
            });
        
            element.addEventListener('blur', function (event) {
                event.preventDefault();
                if (event.relatedTarget !== null) return;
                removeSuggestions();
            });
        }

        if (element.nodeName === 'SELECT' && searchInput) {
            search = searchInput.value;

            function removeOptionElements() {
                let placeholderOption = null;

                while (element.firstChild) {
                    const firstOption = element.firstChild;
                    if (firstOption.nodeName === 'OPTION' && firstOption.hasAttribute('hidden')) {
                        placeholderOption = firstOption;
                    }
                    element.removeChild(firstOption);
                }

                if (placeholderOption) element.append(placeholderOption);
            }

            searchInput.addEventListener('input', function () {
                if (this.value !== search) {
                    if (onInput) onInput(this.value);

                    clearTimeout(typingTimeout);

                    search = this.value || '';

                    if (search.length >= 2) {
                        spinnerParentElement.append(spinnerElement);

                        typingTimeout = setTimeout(function () {
                            getOptions(
                                search,
                                function (options) {
                                    if (options && options.length) {
                                        removeOptionElements();

                                        for (let i = 0; i < options.length; i++) {
                                            const optionElement = document.createElement('option');
                                            optionElement.setAttribute('value', options[i].value);
                                            optionElement.innerHTML = options[i].label;
                                            element.append(optionElement);
                                        }

                                        spinnerParentElement.removeChild(spinnerElement);
                                    } else {
                                        removeOptionElements();
                                        spinnerParentElement.removeChild(spinnerElement);
                                    }
                                },
                                function () {
                                    removeOptionElements();
                                    spinnerParentElement.removeChild(spinnerElement);
                                }
                            );
                        }, 500);
                    } else {
                        removeOptionElements();
                    }
                }
            });

            /* TODO: get selected option */
            element.addEventListener('change', function () {
                if (onChange) onChange(this.value);
            });
        }
    }
}
